import disciplinaryActivity from '@/api/disciplinary-activity'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return disciplinaryActivity.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return disciplinaryActivity.store(data)
  },

  async find(context, id) {
    return await disciplinaryActivity.find(id)
  },

  update(context, data) {
    return disciplinaryActivity.update(data)
  },

  delete(context, data) {
    return disciplinaryActivity.destroy(data)
  },

  getPenalty(context, data) {
    return disciplinaryActivity.penalty(data)
  }
}
